import React, { useEffect, useState } from 'react'
import AsyncSelect from 'react-select/async'
import Select from 'react-select'
import debounce from 'debounce-promise'
import messages from "./messages";
import {FormattedMessage, useIntl} from "react-intl";
import useCurrentUser from 'hooks/useCurrentUser'

const partners = {
  '0': { value: '0', label: 'Denmark' },
  '6': { value: '6', label: 'United Kingdom' },
  '7' :{ value: '7', label: 'South Africa' },
  '5' :{ value: '5', label: 'United States' },
}

const FinanceTerms = ({ state, setState }) => {
  const currentUser = useCurrentUser()
  const loadOptions = debounce((query) => {
    return new Promise((resolve, reject) => {
      fetch('/rest/v2/accounting_payment_term?pageSize=100')
        .then(response => response.json())
        .then((list) => {
          resolve(list.map((item) => ({ value: item.uid, label: item.name })))
        })
        .catch(reject)
    })
  }, 250)

  useEffect(() => {
    if (state.economicDebtorGroupHandle !== '0') {
      fetch(`/rest/v1/accounting_debtor_group/${state.economicDebtorGroupHandle}`)
        .then((response) => response.json())
        .then((data) => {
          setState({...state, economicDebtorGroupHandleObject: {value: data.uid, label: data.name}});
        });
    }
  }, [])

  const { formatMessage } = useIntl()
  return (
    <div className="mb-6 grid grid-cols-2 gap-4">
      <div>
        <div className="text-gray-500 mb-2">Payment Terms</div>
        <AsyncSelect
          value={{ label: state.payment_terms.name, value: parseInt(state.payment_terms.uid) }}
          onChange={({ value, label }) => setState((state) => ({
            ...state,
            economicTermOfPaymentHandle: value,
            payment_terms: {
              name: label,
              uid: value,
            }
          }))}
          loadOptions={loadOptions}
          openMenuOnFocus
          defaultOptions
        />
      </div>

      <div>
        <div className="text-gray-500 mb-2">
          <span><FormattedMessage {...messages.owner}/>
            (<a onClick={() => window.alert(formatMessage(messages.ownerAlert))} className="text-primary cursor-pointer">
                <FormattedMessage{...messages.why}/>
            </a>)
          </span>
        </div>
        <Select
          value={partners[state.partner]}
          openMenuOnFocus
          options={Object.values(partners)}
          isDisabled
        />
      </div>

      { currentUser.roles.includes("finance") &&
        <div>
          <div className="text-gray-500 mb-2"><FormattedMessage {...messages.economicDebtorGroup}/></div>
          <AsyncSelect
            value={state.economicDebtorGroupHandleObject ? state.economicDebtorGroupHandleObject : null}
            onChange={( selection ) => setState((state) => ({
              ...state,
              economicDebtorGroupHandle: selection.value,
              economicDebtorGroupHandleObject: selection
            }))}
            loadOptions={
              debounce((query) => fetch(`/rest/v1/accounting_debtor_group?search[name]=${query}`)
                .then((response) => response.json())
                .then((result) => result.map(({ uid, name }) => ({ value: uid, label: name })))
              , 250)
            }
            openMenuOnFocus
            defaultOptions
          />
        </div>
      }
    </div>
  )
}

export default FinanceTerms
